import { Loader2Icon } from "lucide-react";
import { cn } from "@src/lib/utils";

export interface SpinnerProps extends React.SVGProps<SVGSVGElement> {
  /** Preset pixel size. `sm` = 16, `md` = 24, `lg` = 32. */
  size?: "sm" | "md" | "lg";
  /** Optional caption shown after the spinner. */
  label?: string;
}

const SIZE_CLASS: Record<NonNullable<SpinnerProps["size"]>, string> = {
  sm: "size-4",
  md: "size-6",
  lg: "size-8",
};

/**
 * Wrapper around lucide's `Loader2` that spins continuously. Accepts a
 * `label` prop to render a simple inline caption.
 */
function Spinner({ className, size = "sm", label, ...props }: SpinnerProps) {
  const iconClass = cn(SIZE_CLASS[size], "animate-spin", className);

  if (label) {
    return (
      <span className="inline-flex items-center gap-2 text-muted-foreground">
        <Loader2Icon
          role="status"
          aria-label={label}
          className={iconClass}
          {...props}
        />
        <span className="text-sm">{label}</span>
      </span>
    );
  }

  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={iconClass}
      {...props}
    />
  );
}

export { Spinner };
